import React, { useState, useEffect, useRef } from "react";
import { AllJobDetails, UserProfileType } from "../../../redux/auth/authTypes";
import { CalenderIcon, PaperClipIcon, PlusIconCircle } from "../../Icon";
import DatePicker from "react-datepicker";
import { Label } from "reactstrap";
import moment from "moment";
import Reporting from "./Reporting";
import Select from "react-select";
import { handleDate } from "../../../utils/commonFunctions";
import { CircularAvatar, DropDown } from "../../commons";
import { components } from "react-select";
import MultipleUpload from "../../commons/Upload/MultipleUpload";
import ImagePreview from "../../FileManager/Files/ImagePreview";
import ImageModal from "../../../screens/AdminReports/OpenItemsProgressReports/ImageModal";
import { singleImagePreview } from "../../../utils/invoiceGeneration/commonFunctions";
import toast from "react-hot-toast";
import JobDetailsFormInput from "./JobDetailsFormInput";
import { MasterEmailerList } from "../../../redux/masterData/masterTypes";
import { DropDownUserType } from "../../TimeSheetReports/TimeSheetSummaryReport/TimeSheetSummaryReportHeader";
import { DropDownType } from "../../../commonTypes/clientDirectoryTypes";

type FinacUserDropDownType = {
  value: number | null;
  label: string;
  image: string | undefined;
};

export type AccordianJobDetailsType = {
  is_default: boolean;
  isOpen: boolean;
  isDeleteIcon: boolean;
  job_info: {
    employee_id: string | null;
    job_title: string;
    department: DropDownType[] | [];
    external_department: string;
    start_date: string | null;
    end_date: string | null;
    probation_end_date: string | null;
    total_experience: string;
    rejoin_date: string | null;
    date_of_notice: string | null;
    date_of_relieve: string | null;
    date_of_conformation: string | null;
    client: number | null;
    show_client: DropDownUserType[] | [];
  };
  reporting_details: {
    it_assets_assigned: string;
    reporting_person: number | null;
    show_reporting_person: any;
    coach: number | null;
    show_coach: DropDownUserType[] | [];
  };
  file_attachment: any[];
  emailer_settings: any[];
  show_emailer_settings: any[];
};

type AppProps = {
  data: AllJobDetails;
  isEdit?: boolean;
  handleJobDeatilsForm?: (data: any) => void;
  setProfileForm?: any;
  history: any;
  finalClientList: DropDownUserType[] | [];
  clientSelected?: any;
  handleChangeClient?: (data: any) => void;
  handleRemoveJobDetailsRow: (index: number) => void;
  handleAddAnotherJobDetails: (data: any) => void;
  clientFetching?: boolean;
  setClientText?: React.Dispatch<React.SetStateAction<string>>;
  setEmailerText?: React.Dispatch<React.SetStateAction<string>>;
  setText?: React.Dispatch<React.SetStateAction<string>>;
  setAccordianJobDetailsData?: React.Dispatch<React.SetStateAction<any>>;
  setClientOffset: React.Dispatch<React.SetStateAction<number>>;
  setEmailerOffset: React.Dispatch<React.SetStateAction<number>>;
  setfinacUsersOffset: React.Dispatch<React.SetStateAction<number>>;
  checkClientBottom?: () => void;
  profileForm: UserProfileType;
  oldAttachement?: any;
  uploadData: any;
  setUploadData: any;
  accordianJobDetails?: any;
  accordianJobDetailsData?: any;
  finalFinacAssetList: any;
  finacUsersList: any;
  emailList?: MasterEmailerList[] | [];
  setUsersDepartmentText: React.Dispatch<React.SetStateAction<string>>;
  setUsersDepartmentOffset: React.Dispatch<React.SetStateAction<number>>;
  finalUsersDepartmentList: any;
  usersDepartmentFetching: boolean;
  checkUsersDepartmentBottom?: () => void;
  userType?: string;
  finacAssetApiCall: (index: number) => void;
  setFinacAssetText: React.Dispatch<React.SetStateAction<string>>;
  setFinacAssetOffset: React.Dispatch<React.SetStateAction<number>>;
  probationField?: string;
};
const JobDetails = ({
  data,
  isEdit,
  handleJobDeatilsForm,
  setAccordianJobDetailsData,
  setProfileForm,
  finalClientList,
  finalFinacAssetList,
  clientSelected,
  history,
  handleChangeClient,
  clientFetching,
  setClientText,
  checkClientBottom,
  profileForm,
  oldAttachement,
  uploadData,
  setUploadData,
  accordianJobDetails,
  accordianJobDetailsData,
  handleAddAnotherJobDetails,
  handleRemoveJobDetailsRow,
  finacUsersList,
  emailList,
  setClientOffset,
  setEmailerOffset,
  setfinacUsersOffset,
  setText,
  setEmailerText,
  setUsersDepartmentText,
  setUsersDepartmentOffset,
  finalUsersDepartmentList,
  checkUsersDepartmentBottom,
  usersDepartmentFetching,
  userType,
  finacAssetApiCall,
  setFinacAssetText,
  setFinacAssetOffset,
  probationField,
}: AppProps) => {
  let containerName: any = process.env.REACT_APP_USER_CONTAINER_NAME;
  const [modal, toggleModal] = useState<boolean>(false);
  const [imageIndex, setImageIndex] = useState<number | null>(null);
  const [imagePreviewIndex, setImagePreviewIndex] = useState<number | null>(
    null
  );
  const [showImagePreview, setShowImagePreview] = useState<boolean>(false);
  const [showPopUpContentModal, setShowPopUpContentModal] =
    useState<boolean>(false);
  const [uploadSuccessArray, setUploadSuccessArray] = useState<any>([]);
  const [uploadImageData, setUploadImageData] = useState<any>([]);
  const [showFileUploadModal, setShowFileUploadModal] =
    useState<boolean>(false);
  const [renderImageData, setRenderImageData] = useState<boolean>(false);
  const [imageDetails, setImageDetails] = useState<any>({
    imageUrl: "",
    downloadImage: "",
    fileType: "",
    finalFileName: "",
    updateBy: "",
    updatedAt: "",
  });
  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;
  const [finalFinacAssetData, setFinalFinacAssetData] = useState<any>([]);

  useEffect(() => {
    let temp = accordianJobDetailsData;
    let isDefaultPresent = temp?.filter((el: any) => el?.is_default === true);
    if (isDefaultPresent?.length === 0) {
      temp?.forEach((el: any, index: number) => {
        if (index === 0) {
          el.is_default = true;
        }
      });
      setAccordianJobDetailsData?.([...temp]);
    }
  }, []);

  useEffect(() => {
    setUploadImageData([]);
  }, [imageIndex]);

  useEffect(() => {
    if (uploadImageData?.length && imageIndex !== null) {
      const uniqueTemp = uploadImageData?.filter(
        (value: any, index: number, self: any) =>
          index === self.findIndex((e: any) => e.file_name === value.file_name)
      );
      let temp = accordianJobDetailsData;
      if (temp[imageIndex]?.file_attachment?.length) {
        temp[imageIndex].file_attachment = [
          ...temp[imageIndex]?.file_attachment,
          ...uniqueTemp,
        ];
      } else {
        temp[imageIndex].file_attachment = uniqueTemp;
      }
      setAccordianJobDetailsData?.([...temp]);
    }
  }, [uploadImageData]);

  useEffect(() => {
    let temp = accordianJobDetailsData;
    temp?.forEach((el: any) => {
      const uniqueTemp = el?.file_attachment?.filter(
        (value: any, index: number, self: any) =>
          index === self.findIndex((e: any) => e.file_name === value.file_name)
      );
      el.file_attachment = uniqueTemp;
    });
    setAccordianJobDetailsData?.([...temp]);
  }, [uploadImageData]);

  const resetImageUrl = () => {
    setImageDetails({
      imageUrl: "",
      downloadImage: "",
      fileType: "",
      finalFileName: "",
      updateBy: "",
      updatedAt: "",
    });
  };

  useEffect(() => {
    resetImageUrl();
    if (imagePreviewIndex !== null) {
      let isDelete = false;
      const imageFile = accordianJobDetailsData[
        imagePreviewIndex
      ]?.file_attachment?.map((data: any, index: number) => {
        let file_type = data?.file_url?.split(".");
        if (
          file_type[file_type?.length - 1] === "png" ||
          file_type[file_type?.length - 1] === "jpg" ||
          file_type[file_type?.length - 1] === "jpeg"
        ) {
          return data;
        } else {
          setImageDetails({
            ...accordianJobDetailsData[imagePreviewIndex]?.file_attachment[0],
            imageUrl:
              blobBaseUrl +
              accordianJobDetailsData[imagePreviewIndex]?.file_attachment[0]
                ?.file_url +
              "?" +
              blobToken,
            downloadImage:
              accordianJobDetailsData[imagePreviewIndex]?.file_attachment[0]
                ?.file_url,
            fileType:
              accordianJobDetailsData[imagePreviewIndex]?.file_attachment[0]
                ?.file_type,
            finalFileName:
              accordianJobDetailsData[imagePreviewIndex]?.file_attachment[0]
                ?.file_name,
          });
        }
      });
      if (imageFile?.length > 0) {
        if (imageFile[0]?.file_url) {
          getImageDetails(imageFile[0], "j");
        }
      }
    }
  }, [uploadImageData, imagePreviewIndex, renderImageData]);

  useEffect(() => {
    if (
      imagePreviewIndex !== null &&
      accordianJobDetailsData[imagePreviewIndex]?.file_attachmen?.length > 1
    )
      renderFilesList();
  }, [accordianJobDetailsData, renderImageData]);

  useEffect(() => {
    let temp = JSON.parse(JSON.stringify(accordianJobDetailsData));
    let id: any = [];
    temp?.map((el: any) => {
      el?.reporting_details?.far_assigned_details?.map((singleEl: any) => {
        if (
          singleEl?.far_it_assets_assigned?.value &&
          !singleEl?.far_end_date
        ) {
          id.push(singleEl?.far_it_assets_assigned?.value);
        }
      });
    });
    if (!!id[0]) {
      let filterData = finalFinacAssetList?.filter((item: any) => {
        return !id?.includes(item?.value);
      });
      setFinalFinacAssetData([...filterData]);
    } else {
      setFinalFinacAssetData([...finalFinacAssetList]);
    }
  }, [finalFinacAssetList, accordianJobDetailsData]);

  const handleAddMoreFarDetails = (index: number) => {
    let temp = JSON.parse(JSON.stringify(accordianJobDetailsData));
    let farAssignRate = JSON.parse(
      JSON.stringify(temp[index]?.reporting_details?.far_assigned_details)
    );

    farAssignRate?.push({
      far_it_assets_assigned: {
        far_id: "",
        asset_description: "Select...",
        label: "Select...",
        value: "",
      },
      far_start_date: "",
      far_end_date: "",
    });
    temp[index] = {
      ...temp[index],
      reporting_details: {
        ...temp[index]?.reporting_details,
        far_assigned_details: farAssignRate,
      },
    };
    setAccordianJobDetailsData?.([...temp]);
  };

  const handleDeleteFarDetails = (index: number, rowIndex: number) => {
    let temp = JSON.parse(JSON.stringify(accordianJobDetailsData));
    let farAssignRate = JSON.parse(
      JSON.stringify(temp[index]?.reporting_details?.far_assigned_details)
    );
    let finalFilteredFar = farAssignRate?.filter(
      (_: any, farIndex: number) => farIndex !== rowIndex
    );
    temp[index] = {
      ...temp[index],
      reporting_details: { far_assigned_details: finalFilteredFar },
    };
    setAccordianJobDetailsData?.([...temp]);
  };

  const handleJobDeatilsFormChange = (
    objKey: any,
    dataKey: any,
    value: any,
    index: number,
    rowIndex?: number
  ) => {
    let temp = accordianJobDetailsData;
    if (objKey === "job_info") {
      if (value !== "Invalid date") {
        if (dataKey === "client") {
          temp[index].reporting_details["far_assigned_details"] = [
            {
              far_it_assets_assigned: {
                far_id: "",
                asset_description: "Select...",
                label: "Select...",
                value: "",
              },
              far_start_date: "",
              far_end_date: "",
            },
          ];
          temp[index].job_info[dataKey] = value?.value;
          temp[index].job_info["show_client"] = value;
        } else if (dataKey === "department") {
          temp[index].job_info["department"] = {
            label: value?.label,
            value: value?.value,
          };
        } else if (dataKey === "start_date") {
          temp[index].job_info["probation_end_date"] =
            probationField === "Probation" &&
            moment(value).add(6, "months").format("YYYY-MM-DD");
          temp[index].job_info["start_date"] = value;
        } else {
          temp[index].job_info[dataKey] = value;
        }
      } else {
        temp[index].job_info[dataKey] = null;
      }
    } else if (objKey === "reporting_details") {
      if (dataKey === "reporting_person") {
        temp[index].reporting_details[dataKey] = value?.value;
        temp[index].reporting_details["show_reporting_person"] = value;
      } else if (dataKey === "coach") {
        temp[index].reporting_details[dataKey] = value?.value;
        temp[index].reporting_details["show_coach"] = value;
      } else if (dataKey === "far_it_assets_assigned") {
        temp[index].reporting_details["far_assigned_details"][
          rowIndex ? rowIndex : 0
        ]["far_it_assets_assigned"] = value;
      } else if (dataKey === "far_start_date") {
        temp[index].reporting_details["far_assigned_details"][
          rowIndex ? rowIndex : 0
        ]["far_start_date"] = value;
      } else if (dataKey === "far_end_date") {
        temp[index].reporting_details["far_assigned_details"][
          rowIndex ? rowIndex : 0
        ]["far_end_date"] = value;
      } else {
        temp[index].reporting_details[dataKey] = value;
      }
    } else if (objKey === "empty") {
      temp[index][dataKey] = value;
      temp?.forEach((el: any, i: number) => {
        if (i !== index) {
          el.is_default = false;
        }
      });
    } else if (dataKey === "emailer_settings") {
      temp[index][dataKey] = value?.map((item: any) => item?.value);
      temp[index]["show_emailer_settings"] = value;
    }
    setAccordianJobDetailsData?.([...temp]);
  };
  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label.split("%")[0]}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };

  const handleEditFileList = (imageUrl: string) => {
    setRenderImageData(!renderImageData);
    let tempFileData = JSON.parse(JSON.stringify(accordianJobDetailsData));
    if (imagePreviewIndex !== null) {
      tempFileData[imagePreviewIndex].file_attachment = tempFileData[
        imagePreviewIndex
      ]?.file_attachment?.filter((e: any) => e?.file_url !== imageUrl);
      setAccordianJobDetailsData?.([...tempFileData]);
    }
  };
  const getImageDetails = (data: any, index: any) => {
    setImageDetails({
      ...data,
      imageUrl: blobBaseUrl + data.file_url + "?" + blobToken,
      downloadImage: data.file_url,
      fileType: data.file_type,
      finalFileName: data.file_name,
    });
  };
  const renderFilesList = () => {
    const isDelete = false;
    if (
      imagePreviewIndex !== null &&
      accordianJobDetailsData[imagePreviewIndex]?.file_attachment?.length > 0
    ) {
      const finalFileList =
        accordianJobDetailsData[imagePreviewIndex]?.file_attachment?.length >
          0 &&
        accordianJobDetailsData[imagePreviewIndex]?.file_attachment?.map(
          (data: any, index: number) => {
            return singleImagePreview(
              data,
              index,
              getImageDetails,
              handleEditFileList,
              setShowPopUpContentModal,
              isDelete,
              accordianJobDetailsData[imagePreviewIndex]?.file_attachment
            );
          }
        );

      return finalFileList;
    }
  };

  return (
    <>
      <div className="form-group" style={{ marginTop: "15px" }}>
        <div className="d-flex" style={{ gap: "2%" }}>
          <div>
            <p
              style={{ fontSize: "20px", fontWeight: 500, marginBottom: "6px" }}
            >
              Job Details
            </p>
            <h4 style={{ marginBottom: "29px", color: "#5c6177" }}>
              Update your job details here
            </h4>
          </div>
          <div className="row mt-3">
            <div className="col-md-12">
              <button
                className="btn btn-outline"
                onClick={handleAddAnotherJobDetails}
              >
                <span>
                  <PlusIconCircle /> Add More
                </span>
              </button>
            </div>
          </div>
        </div>
        <JobDetailsFormInput
          accordianJobDetails={accordianJobDetails}
          handleJobDeatilsFormChange={handleJobDeatilsFormChange}
          accordianJobDetailsData={accordianJobDetailsData}
          handleRemoveJobDetailsRow={handleRemoveJobDetailsRow}
          finalClientList={finalClientList}
          finacUsersList={finacUsersList}
          finalFinacAssetList={finalFinacAssetData}
          handleAddMoreFarDetails={handleAddMoreFarDetails}
          handleDeleteFarDetails={handleDeleteFarDetails}
          emailList={emailList}
          setEmailerOffset={setEmailerOffset}
          setfinacUsersOffset={setfinacUsersOffset}
          setClientOffset={setClientOffset}
          checkClientBottom={checkClientBottom}
          setImageDetails={setImageDetails}
          setShowFileUploadModal={setShowFileUploadModal}
          setUploadData={setUploadData}
          uploadData={uploadData}
          setImageIndex={setImageIndex}
          imageIndex={imageIndex}
          setImagePreviewIndex={setImagePreviewIndex}
          setUploadImageData={setUploadImageData}
          renderFilesList={renderFilesList}
          imageDetails={imageDetails}
          resetImageUrl={resetImageUrl}
          handleEditFileList={handleEditFileList}
          setClientText={setClientText}
          setEmailerText={setEmailerText}
          setText={setText}
          imagePreviewIndex={imagePreviewIndex}
          setUsersDepartmentText={setUsersDepartmentText}
          setUsersDepartmentOffset={setUsersDepartmentOffset}
          finalUsersDepartmentList={finalUsersDepartmentList}
          checkUsersDepartmentBottom={checkUsersDepartmentBottom}
          usersDepartmentFetching={usersDepartmentFetching}
          userType={userType}
          finacAssetApiCall={finacAssetApiCall}
          setFinacAssetText={setFinacAssetText}
          setFinacAssetOffset={setFinacAssetOffset}
          probationField={probationField}
          isEdit={isEdit && isEdit}
        />
      </div>
    </>
  );
};

export default JobDetails;
